// extracted by mini-css-extract-plugin
module.exports = {"cellLink":"TransactionsTableCrypto_cellLink__TVtMi","copyButton":"TransactionsTableCrypto_copyButton__5Lcbb","copyButtonIcon":"TransactionsTableCrypto_copyButtonIcon__0GySq"};